import { useRef, useEffect } from 'react';
import { useSpring, animated } from 'react-spring';
import { jsx } from 'react/jsx-runtime';

const Count = ({
  count,
  className,
  style,
  maxCount,
  animateCount
}) => {
  const ref = useRef(0);
  const oldCount = ref.current;
  const props = useSpring({
    to: [{
      display: 'block',
      transform: 'scale(0.4)'
    }, {
      display: 'block',
      transform: 'scale(1)'
    }],
    from: {
      display: 'block',
      transform: 'scale(0.4)'
    },
    reset: true,
    reverse: count === oldCount,
    delay: 20
  });
  useEffect(() => {
    if (ref) {
      ref.current = count;
    }
  }, [count]);
  const countResult = maxCount && count && count > maxCount ? `${maxCount}+` : count;
  return animateCount ? /*#__PURE__*/jsx("span", {
    className: className,
    style: style,
    children: /*#__PURE__*/jsx(animated.span, {
      style: props,
      children: countResult
    })
  }) : /*#__PURE__*/jsx("span", {
    className: className,
    style: style,
    children: countResult
  });
};

export { Count };
